import { template as loDashTemplate } from 'lodash';
export const template = (message, args) => loDashTemplate(message)(args);



// WEBPACK FOOTER //
// ./src/javascripts/app/entity_editor/Components/template.es6.js